define.alias("shared/services/shared/popup-manager", "settings/services/shared/popup-manager");